var ExitLowerBanner = {
    bannerOpened: false,
    interval: null,
    lastInteraction: null,

    init: function () {
        if (!Device.isMobile()) {
            return;
        }

        this.updateLastInteraction();

        const banner = jQuery('#exit_lower_banner');
        if (banner.length > 0) {
            this.interval = setInterval(() => {
                const currentTime = (new Date()).getTime();
                const delta = 8000;

                if (this.lastInteraction + delta < currentTime) {
                    clearInterval(this.interval);
                    this.showBanner();
                }
            }, 1000);

            jQuery(document).on('scroll', () => {
                if (this.bannerOpened) {
                    return;
                }

                this.updateLastInteraction();

                const scrollTop = jQuery(document).scrollTop();
                let scrollToItem = 5;

                if (jQuery('.single-vendor').length < scrollToItem) {
                    scrollToItem = jQuery('.single-vendor').length;
                }

                const vendorItem = jQuery('.single-vendor:nth-child(' + scrollToItem + ')');
                const showFrom = vendorItem.offset().top - vendorItem.outerHeight();

                if (showFrom < scrollTop) {
                    clearInterval(this.interval);
                    this.showBanner();
                }
            });
        }
    },

    showBanner: function () {
        this.bannerOpened = true;
        jQuery.cookie('_exit_ppc_pp', true);

        const $banner = jQuery('#exit_lower_banner');
        $banner.removeClass('hidden');

        GAEvents.sendEvent('exit popup', 'impression - ' + GAEvents.getPageName(window.location.href), $banner.data('vendor'), true);

        if (typeof aloomaPageData !== 'undefined' && typeof aloomaSendEvent !== 'undefined') {
            let aloomaData = jQuery.extend({}, aloomaPageData);

            if (typeof $banner.attr("data-name") !== "undefined" && $banner.attr("data-name") !== "") {
                aloomaData.pop_name = $banner.attr("data-name");
            }

            let vendor_id = $banner.data("vendor-id");
            if (vendor_id) {
                aloomaData.vendor_id = vendor_id;
            }

            aloomaSendEvent('exit_intent_fired', aloomaData);
        }

        setTimeout(() => {
            applyAloomaTracking();
        }, 300);

        jQuery(document).on('click', '#exit_lower_banner #cboxClose', function () {
            $banner.addClass('hidden');

            const label = $banner.data('vendor');

            if (typeof label !== 'undefined' && label.length) {
                const pageName = GAEvents.getPageName(window.location.href);
                GAEvents.sendEvent('click in', 'X: close <– ' + pageName + ' (exit-popup)', label);
            }
        });

        document.addEventListener('click', (e) => {
            if (!$banner.get()[0].contains(e.target)) {
                $banner.addClass('hidden');
            }
        });
    },

    updateLastInteraction: function () {
        this.lastInteraction = (new Date()).getTime();
    },
};

ExitLowerBanner.init();
